// See ~/Resources/app/clusters/jda-bespoke-embed/jda-video-input.js for more details.

app.ui.registerUi('embed', function(app) {
	var helpers = app.helpers.funcs;
	return {
		implementationExists: function() {
			return jQuery.fn.jdaBespokeEmbed ? true : false;
		},
        onLoaded: function (data) {
            if (data.hasJustLoaded([RESOURCE_NAME__DOM, RESOURCE_NAME__YOUTUBE])) {
                this.init();
            }
        },
        init: function ($scope) {
            if (!this.implementationExists()) return;
            var $beElems = helpers.resolveScope('.jda-bespoke-embed-seed', $scope);
            $beElems.jdaBespokeEmbed({
				addGlobalEventFunction: function(eventKey, func) {
                    var appEventKey;
                    if (eventKey == 'resize') appEventKey = EVENT_NAME__GENERAL__RESIZE;
                    if (eventKey == 'scroll') appEventKey = EVENT_NAME__GENERAL__SCROLL;
					app.globalEventRegistry.addListener(appEventKey, func);
				}
            });
		}
	};
});
